<template>
    <b-modal
      id="ag-logDeleteModal"
      class="agModal"
      ref="modal"
      centered
      no-close-on-esc
      no-close-on-backdrop
      @keyup.enter.native="applyDeleteButton_click">
      <template slot="modal-header">
        <h4 class="agModal-title">Delete Logs</h4>
      </template>
      <div class="agInputGroup">
        <input 
            type="checkbox" 
            v-model="allLogs"/>
        <label>Delete all logs for workspace</label>
      </div>
      <div class="agInputGroup">
        <label>Logs before date:</label>
        <datetime 
          v-model="logDate"
          type="datetime"
          format="M/dd/yy h:mm a"
          :phrases="{ok: 'Set', cancel: 'Cancel'}"
          :disabled="allLogs">
        </datetime>
      </div>
      <template slot="modal-footer" slot-scope="{cancel}">
        <b-button class="agModal-buttonLeft" @click="cancel">Cancel</b-button>
        <b-button class="agModal-buttonRight" variant="danger" @click="applyDeleteButton_click">Delete</b-button>
      </template>

    <!-- connection delete confirmation -->
    <b-modal
      ref="confirmModal"
      class="agModal"
      centered
      no-close-on-esc
      no-close-on-backdrop
      @keyup.enter.native="confirmDeleteButton_click">
      <template slot="modal-header">
        <h4 class="agModal-title danger">Are you sure?</h4>
      </template>
      Are you sure you want to delete this workspace's logs? This cannot be undone.
      <template slot="modal-footer" slot-scope="{cancel}">
        <b-button class="agModal-buttonLeft" @click="cancel">Cancel</b-button>
        <b-button
          class="agModal-buttonRight"
          variant="danger"
          @click="confirmDeleteButton_click"
        >Delete</b-button>
      </template>
    </b-modal>

    </b-modal>
</template>


<script>

// components
import { Datetime } from "vue-datetime";

// modules
import Util from "src/util/util";
import Moment from "moment";

export default 
{
    name: "ag-logDelete-modal",
    components: {
        "datetime" : Datetime
    },
    props: {
        
    },
    data(){
        return {
           allLogs: false,
           logDate: ""
        };
    },
    computed:  {
       
    },
    methods: 
    {
        // UI Events

        applyDeleteButton_click() {
            this.$refs.confirmModal.show();
        },

        confirmDeleteButton_click() {
            this.$refs.confirmModal.hide();
            var workspace = this.$store.state.wsStore.workspace._id;
            if(this.allLogs) {
              this.$store.dispatch("logStore/deleteLogs", {workspace});
            }
            else {
              this.$store.dispatch("logStore/deleteLogs", {workspace: workspace, date: this.logDate});
            }
            this.$refs.modal.hide();
        },

        // other

        show(){
          setTimeout(() => {
            this.$refs.modal.show();
          }, 250);
        },

        hide(){
          this.$refs.modal.hide();
        },
    }
};

</script>


<style scoped lange="css">


</style>


// WEBPACK FOOTER //
// src/components/log/DeleteModal.vue